/** @jsxImportSource @emotion/react */

// import { useQuery } from "@tanstack/react-query";
import { gameProviderJson } from "constants/desktop-game";
// import { QueryKeys } from "constants/queryKeys";
// import handleLoginGame from "helpers/handleLoginGame";

import { ItemMenu } from "../list-menu";
import { DropdownMenuStyle } from "./index.style";
import { handleGameTransferPoint } from "helpers/handleModal";
import { useAppContext } from "contexts/app.context";
import { ModalTypeValue } from "enums/modalType";

type Props = {
  menuItem: ItemMenu;
  isActive: boolean;
};

export const gameProviderNames: Record<string, string> = {
  "Dream Gaming": "DG真人",
  "Allbet Gaming": "歐博真人",
  "SA Gaming": "沙龍真人",
  "WM Gaming": "WM真人",
  "Yeebet Gaming": "億博真人",
  "GR SLOT": "魔龍電子",
  "DB SLOT": "DB電子",
  "RTG SLOT": "RTG電子",
  "DT SLOT": "DT電子",
  "BNG SLOT": "BNG電子",
  "IBEX SLOT": "IBEX電子",
  "RSG SLOT": "RSG電子",
  "ATG SLOT": "ATG電子",
  "ZEBRA SLOT": "ZEBRA電子",
  "GR CHESS": "魔龍棋牌",
  "Gordon CHESS": "高登棋牌",
  "9K CHESS": "9K棋牌",
  "ATG CHESS": "ATG棋牌",
  "SUPER sportbook": "SUPER體育",
  "Alaba Sports": "阿拉八體育",
  "GR Fishing": "魔龍捕魚",
  "SP Fishing": "SP捕魚",
  "SUPER lotery": "SUPER彩票",
  "9k lotery": "9k彩票",
  "ATG lotery": "ATG彩票",
  "IBEX": "IBEX",
};

function DropdownMenu({ menuItem, isActive }: Props) {
  // const { data: username } = useQuery<string>([QueryKeys.username]);
  const { state, dispatch } = useAppContext();

  const games = gameProviderJson[menuItem.code + ""] || [];
  if (!games?.length) return null;
  return (
    <div css={DropdownMenuStyle.index(isActive, "ct")}>
      <div className="bg_menuShadow"></div>
      <div className={`subList`}>
        {Array.isArray(games) &&
          games.map((item, index) => {
            return (
              <div
                className="item"
                css={DropdownMenuStyle.item()}
                key={index}
                onClick={() => {
                  if (
                    menuItem.isSubGame &&
                    item.provider_code !== "GFGD" &&
                    item.provider_code !== "NK"
                  ) {
                    return window.open(
                      `${menuItem.code}/${item.provider_code}`,
                      "subGame",
                    );
                  }
                  handleGameTransferPoint(
                    state,
                    dispatch,
                    ModalTypeValue.GAME_TRANSFER_POINT,
                    item,
                  );
                  // handleLoginGame(item, username as string);
                }}
              >
                <div className="listLogo">
                  <div className={`img_logo img_logo-${item.provider_code}`}>
                    <img loading="lazy" src={item.icon} alt="" />
                  </div>
                  <div className="listName">
                    {gameProviderNames[item.provider_name || ""] || item.provider_name}
                  </div>
                </div>
                <img className="Darkened2" src={item.picture} alt="..." />
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default DropdownMenu;
